










import { Vue, Component } from 'vue-property-decorator';
import Calendarios from '@/pantallas/Calendarios/Calendarios.vue';

@Component({
  components: { Calendarios },
})
export default class CalendariosPantalla extends Vue {}
